import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["company", "client", "workflow"]

  connect() {
    this.filter()
  }

  filter() {
    const companyId = this.companyTarget.value
    this.filterOptions(this.clientTarget, companyId)
    this.filterOptions(this.workflowTarget, companyId)
  }

  filterOptions(select, companyId) {
    Array.from(select.options).forEach((option) => {
      if (!option.value) return

      const companyIds = option.dataset.companyIds?.split(" ") || []
      const available = companyIds.includes(companyId)
      option.disabled = !available
      option.hidden = !available
    })

    if (select.selectedOptions[0]?.disabled) select.value = ""
  }
}
